import { useQuery } from "react-query";
import axios from "infra/http";
import { TimelineLog } from "components/TimelineLogs";


function useLogsContaBancaria(tenantId: string, id: string | undefined) {
  return useQuery(
    `v1/tenants/${tenantId}/conta-bancaria/${id}/historico`,
    async () => {
      const { data } = await axios.get<TimelineLog[]>(
        `v1/tenants/${tenantId}/conta-bancaria/${id}/historico`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useLogsContaBancaria;
